import { Updater, UpdaterFn } from "@commonlibs";
import { SortingState } from "@tanstack/react-table";
import useSearchParamGroup from "./useSearchParamGroup";

export interface TableSorting<K extends string = string> {
    order: K;
    orderBy: "ASC" | "DESC";
}

export default function useTableSearchParamSorting<K extends string = string>(...keys: K[]): [TableSorting, UpdaterFn<SortingState>] {
    const [{ order, orderBy }, setSorting] = useSearchParamGroup(
        ["order", { validation: (value) => value === "DESC" || value === "ASC" }],
        ["orderBy", { validation: (value) => keys.includes(value as K) }],
    );

    const handleSortingChange: UpdaterFn<SortingState> = (updater: Updater<SortingState>) => {
        const updaterValidation = orderBy ? [{ id: orderBy, desc: order === "DESC" }] : [];
        const state = typeof updater === "function" ? updater(updaterValidation) : updater;
        const stateValidation = state[0] ? "ASC" : "";
        setSorting({ order: state[0]?.desc ? "DESC" : stateValidation, orderBy: state[0]?.id });
    };

    return [{ order: order as TableSorting<K>["order"], orderBy: orderBy as TableSorting<K>["orderBy"] }, handleSortingChange];
}
